import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../axiosConfig';
import domain from '../../constants/config.js';

const apiDomain = domain.API_BASE_URL;

export const fetchPlanDetails = createAsyncThunk(
  'priceList', // action type
  async (vehicleTypeId) => {
    console.log("vehicleTypeIdvehicleTypeId",vehicleTypeId);
    const apiUrl = apiDomain+'v1/rsa-plans/'+vehicleTypeId
    const response = await api.get(apiUrl);
    console.log("response fetchPlanDetails store", response);
    return response.data;
  }
);


const priceDetailsSlice = createSlice({

  name: 'priceList',
  initialState: {
    apiResponse: [],
    loading: false, // default false
    apiErrorMsg: null,
  },
  reducers: {
    setApiData: (state, action) => {
      state.apiResponse = action.payload;
    },
  },


  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanDetails.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
      })
      .addCase(fetchPlanDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload; //API call completes → fulfilled sets list = response.data
        console.log("Reducer priceDetailsSlice apiResponse",state.apiResponse);
      })
      .addCase(fetchPlanDetails.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      });
  },
});

export const { setApiData, setVehicleTypeId } = priceDetailsSlice.actions;

export default priceDetailsSlice.reducer;
